import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import axios from "axios";
import { getToken } from "../../utils/getToken";
import { toastService } from "../../utils/toastify";

export const getLiveStream = createAsyncThunk(
  "get/live-stream",
  async (payload, { rejectWithValue }) => {
    console.log({ payload });

    try {
      const response = await axiosInstance.get("liveStreamList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const addLiveStream = createAsyncThunk(
  "add/live-stream",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addLiveStream", payload);
      return response.data;
    } catch (error) {
     console.log({ error });
     if (error?.response?.data?.code == 403) {
       toastService.error(error?.response?.data?.message);
       rejectWithValue(error);
     } else {
       toastService.error("LiveStream added failed");
       rejectWithValue(error);
     }
    }
  }
);
export const editLiveStream = createAsyncThunk(
  "edit/live-stream",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editLiveStream", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const liveStreamStatusChanged = createAsyncThunk(
  "edit/live-stream",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "liveStreamStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getCategoryDropDown = createAsyncThunk(
  "get/categoryDropDown",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("categoryDropDown", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getTopicDropDown = createAsyncThunk(
  "get/topicDropDown",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("topicDropDown", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const imageUpload = createAsyncThunk(
  "imageUpload/topic",
  async (payload, { rejectWithValue }) => {
    const token = getToken("adminLogin"); 
    try {
      const response = await axios.post(
        "https://prospuh2learn.com/api/v1/admin/uploadDocument",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getLiveRating = createAsyncThunk(
  "get/liveRating",
  async (payload, { rejectWithValue }) => {
    console.log({ payload });

    try {
      const response = await axiosInstance.get("liveRating", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);

const liveStreamManagement = createSlice({
  name: "liveStreamManagement",
  initialState: {
    liveStreamData: [],
    categoryDropDownData: [],
    topicDropDowndata: [],
    ratingData: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getLiveStream.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLiveStream.fulfilled, (state, action) => {
      state.loading = false;
      state.liveStreamData = action.payload;
    });
    builder.addCase(getLiveStream.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });

    builder.addCase(getCategoryDropDown.fulfilled, (state, action) => {
      state.categoryDropDownData = action.payload;
    });
    builder.addCase(getCategoryDropDown.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getTopicDropDown.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getTopicDropDown.fulfilled, (state, action) => {
      state.loading = false;
      state.topicDropDowndata = action.payload;
    });
    builder.addCase(getTopicDropDown.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getLiveRating.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLiveRating.fulfilled, (state, action) => {
      state.loading = false;
      state.ratingData = action.payload;
    });
    builder.addCase(getLiveRating.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
  },
});

export default liveStreamManagement.reducer;
